import styled from "styled-components";
import DisplaySettingsIcon from '@mui/icons-material/DisplaySettings';
import DoNotDisturbOnIcon from '@mui/icons-material/DoNotDisturbOn';
import api from '../../../axios.js'
import { useDispatch } from 'react-redux';
import { estadoReventa } from "../../../redux/actions/reventaActions.js";
import Button from '@mui/material/Button';
import Revender from './revender.jsx';
import {useState} from "react"

let Container=styled.div`
`;
let ActionReventaContainer=styled.div`
	width:100%;
	height:60%;
	display:flex;
	justify-content:start;
	align-items:center
`;

export default function ActionReventa(props){
	let {reventa}=props;
	let dispatch=useDispatch();
	let [openRevender,setOpenRevender]=useState(false)

	let saveVenta=(id)=>{
		setOpenRevender(true)
	};

	let noRevender=async(id)=>{
		if(window.confirm("dejar de revender este juego?")){
			dispatch(estadoReventa(2))
			try{ 			
	 			await api.delete(`/reventa?id=${id}` );
	 			alert("reventa modificada");
	 			dispatch(estadoReventa(0));	 			
	 		}catch(err){
	 			console.log(err);
	 			alert("error");
	 			dispatch(estadoReventa(0))
	 		}
		}
	}
	
	return(
		<Container>
		{openRevender?<Revender reventa={reventa} isOpen={setOpenRevender} />:null}
			<ActionReventaContainer>
 				<Button onClick={()=>saveVenta(reventa.id)} startIcon={<DisplaySettingsIcon /> }   variant="outlined"  color="success">
        			revendido
      			</Button>
      		</ActionReventaContainer>
      		<ActionReventaContainer>
 				<Button  onClick={()=>noRevender(reventa.id)}  startIcon={<DoNotDisturbOnIcon />}  variant="outlined"  color="error">
        			no revender        		
      			</Button >
      		</ActionReventaContainer>
		</Container>	
	)
}